import { useState, forwardRef } from "react";
import DatePicker from "react-datepicker";
import { CalendarDaysIcon, ChevronDownIcon } from "../../images/icons";
import { Button } from "@biteship/atom";
import moment from "moment";
// import { trackEvent } from "services/analytics";

export default function FilterDate(props) {
  const [dateRange, setDateRange] = useState([moment().valueOf(), moment().valueOf()]);
  const [startDate, endDate] = dateRange;

  const onChangeDate = (update) => {
    const [startDate, endDate] = update;
    setDateRange(update);
    props.onChangeDate(startDate, endDate);
  };

  const DateInput = forwardRef(({ value, onClick }, ref) => (
    <div ref={ref}>
      <Button
        onClick={() => {
          onClick();
          // trackEvent("Ticket FilterDate");
        }}
        title={
          <div className="flex justify-between w-full items-center">
            <div className="flex items-center whitespace-nowrap">
              <CalendarDaysIcon className="w-4 h-4 mr-2 text-gray-700" />{" "}
              <div className={`${props.isActive ? "text-gray-900" : "text-gray-700"}`}>
                {props.isActive ? value : "Filter Tanggal"}
              </div>
            </div>
            <ChevronDownIcon className="w-4 h-4 text-gray-900" />
          </div>
        }
        secondary
        className={`${
          props.isActive ? "border-primary-500" : "border-gray-300"
        } text-gray-700 w-full`}
      />
    </div>
  ));
  return (
    <DatePicker
      selectsRange={true}
      startDate={startDate}
      endDate={endDate}
      onChange={onChangeDate}
      customInput={<DateInput />}
      dateFormat="dd MMM yyyy"
      maxDate={new Date()}
    />
  );
}
